/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */

import React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import { hot } from 'react-hot-loader/root'
import { Masthead } from '@ta-interaktiv/react-masthead'
import { Footer } from '@ta-interaktiv/react-footer'
import { AutofitIFrame } from '@ta-interaktiv/react-autofit-iframe'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import './styles.scss'

const ARTICLE_ID = '25221275'
const ADDITIONAL_SHARES = 6

let baseUrl = window.location.hostname.replace('interaktiv.', '')
baseUrl = baseUrl.replace('.ch', '')
baseUrl.replace(new RegExp('.', 'g'), '')

export class AppComponent extends React.Component<Props, State> {
  constructor(props) {
    super(props)
    this.isMobile = window.innerWidth < 600
    this.isTablet = window.innerWidth < 1025
  }

  render() {
    return (
      <div className='index'>
        <Masthead articleId={ARTICLE_ID} additionalShares={ADDITIONAL_SHARES} />
        <ThemeSwitch />

        {/* TODO Replace the following segment with your project cover */}
        <header className='ui vertical segment'>
          <div className='ui container'>
            <h1 className='ui header'>
              Unsere eigenen Hochrechnungen <span className='beta'>BETA</span>
            </h1>

            <h2 className='ui header'>
              <div className='small sub header'>
                Wir bieten neu an den Abstimmungswochenenden Hochrechnungen zu
                nationalen Vorlagen in Echtzeit an. Haben Sie Anregungen oder
                Verbesserungsvorschläge? Wir freuen uns über Ihre Nachricht an{' '}
                <a href='mailto:interaktiv@tamedia.ch?subject=Abstimmungshochrechnungen'>
                  interaktiv@tamedia.ch
                </a>
                .
              </div>
            </h2>
          </div>
        </header>

        <div className='content'>
          <div className='ui text container' style={{ marginBottom: '3em' }}>
            <AutofitIFrame
              aria-label='Interactive line chart'
              src='https://interaktiv.tagesanzeiger.ch/abstimmungs-hochrechnung/?ballot=6290'
              height={this.isTablet ? (this.isMobile ? '415' : '550') : '550'}
              width='581'
            />
            <p>
              <a href={'https://www.' + baseUrl + '.ch/16164559'}>
                <i className='icon external alternate' />
                Zum Liveticker der Vorlage
              </a>
            </p>
          </div>

          <div className='ui text container' style={{ marginBottom: '3em' }}>
            <AutofitIFrame
              aria-label='Interactive line chart'
              src='https://interaktiv.tagesanzeiger.ch/abstimmungs-hochrechnung/?ballot=6300'
              height={this.isTablet ? (this.isMobile ? '415' : '550') : '550'}
              width='581'
            />
            <p>
              <a href={'https://www.' + baseUrl + '.ch/11878695'}>
                <i className='icon external alternate' />
                Zum Liveticker der Vorlage
              </a>
            </p>
          </div>
        </div>

        <div className='content'>
          <div className='ui text container'>
            <a href={'https://abstimmungen.' + baseUrl + '.ch'}>
              <img src={require('./images/inline-teaser.jpg')} width='100%' />
            </a>
          </div>
        </div>

        <div
          className='ui vertical fitted attached segment'
          id='methodik'
          style={{ marginTop: '3em' }}
        >
          <div
            className='ui text container methodik'
            style={{ position: 'relative', paddingTop: '1em' }}
          >
            <h4 style={{ fontSize: '1.4em' }}>Methodik</h4>

            <p>
              Die Hochrechnung macht bereits früh am Sonntagnachmittag präzise
              Vorhersagen über den Anteil Ja-Stimmen für eidgenössische
              Vorlagen. Das Modell generiert Hochrechnungen für den Ja-Stimmen
              Anteil, berücksichtigt aber nicht das Ständemehr. Das Datenteam
              von <a href='https://leewas.ch'>LeeWas</a> hat das statistische
              Modell mit verschiedenen Werkzeugen des maschinellen Lernens
              entwickelt (künstliche Intelligenz).
            </p>
            <p>
              Als Basis dienen die Abstimmungsdaten auf Gemeindeebene aller
              Abstimmungen der letzten 10 Jahre. Der Algorithmus lernt am
              Abstimmungssonntag fortlaufend wie die aktuelle Vorlage optimal,
              als Funktion aller vergangenen Abstimmungen, berechnet werden
              kann. Mit jedem neuen Gemeinderesultat generiert der Algorithmus
              ein neues Modell und eine neue Hochrechnung.
            </p>
            <p>
              Die Schätzungen werden fortlaufend erneuert und in Echtzeit
              visualisiert. Im Verlauf des Abstimmungssonntags werden die
              Hochrechnungen besser und die statistischen Unsicherheiten nehmen
              ab. Bereits mit der Auszählung 10% aller Schweizer Gemeinden kann
              eine gute erste Hochrechnung vorgenommen werden: Simulationen
              zeigen, dass die maximale Abweichung über 62 Vorlagen bei ±4%
              liegt.
            </p>
          </div>
        </div>

        {/* TODO Add your credits in this component */}

        <Footer
          articleId={ARTICLE_ID}
          additionalShares={ADDITIONAL_SHARES}
          credits={[
            ['Hochrechnungen', '<a href="https://leewas.ch">LeeWas</a>'],
            [
              'Visualisierungskonzept und Programmierung',
              'Mathias Lutz und Marc Brupbacher, Interaktiv-Team'
            ]
          ]}
          questions={[
            'Wie nützlich finden Sie die Hochrechnungen?',
            'Wie verständlich ist die Visualisierung?',
            'Funktioniert die technische Umsetzung?'
          ]}
        />
      </div>
    )
  }
}

export default hot('AppComponent')
